// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-details-container {
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}
html[data-coreui-theme=dark] .user-details-container {
  background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);
  color: var(--cui-body-color, #fff);
}
.user-details-container .user-details-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
}
.user-details-container .user-details-loading p {
  font-size: 1.1rem;
  margin-top: 1rem;
}
.user-details-container .user-details-error,
.user-details-container .user-details-not-found {
  padding: 2rem;
}
.user-details-container .user-details-error .error-alert,
.user-details-container .user-details-error .warning-alert,
.user-details-container .user-details-not-found .error-alert,
.user-details-container .user-details-not-found .warning-alert {
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-size: 1.1rem;
  padding: 1.5rem;
}
.user-details-container .user-details-error .error-alert svg,
.user-details-container .user-details-error .warning-alert svg,
.user-details-container .user-details-not-found .error-alert svg,
.user-details-container .user-details-not-found .warning-alert svg {
  font-size: 1.2rem;
}
.user-details-container .user-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
html[data-coreui-theme=dark] .user-details-container .user-details-header {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.user-details-container .user-details-header .header-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.user-details-container .user-details-header .header-left .back-button {
  border-radius: 12px;
  border: 2px solid #e9ecef;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}
.user-details-container .user-details-header .header-left .back-button:hover {
  border-color: #6c757d;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.user-details-container .user-details-header .header-left .header-title h3 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}
html[data-coreui-theme=dark] .user-details-container .user-details-header .header-left .header-title h3 {
  color: var(--cui-body-color, #fff);
}
.user-details-container .user-details-header .header-left .header-title .header-subtitle {
  font-size: 1rem;
  color: #6c757d;
  font-weight: 500;
}
html[data-coreui-theme=dark] .user-details-container .user-details-header .header-left .header-title .header-subtitle {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .user-details-header .header-actions .dropdown-toggle {
  border-radius: 12px;
  padding: 0.75rem 1rem;
  border: 2px solid #e3f2fd;
  transition: all 0.3s ease;
}
.user-details-container .user-details-header .header-actions .dropdown-toggle:hover {
  border-color: #2196f3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}
.user-details-container .user-profile-card {
  margin-bottom: 2rem;
  border: none;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card {
  background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, var(--cui-dark-bg-subtle, #2c3034) 100%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.user-details-container .user-profile-card .card-body {
  padding: 2.5rem;
}
.user-details-container .user-profile-card .profile-avatar-section {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 2rem;
}
@media (min-width: 992px) {
  .user-details-container .user-profile-card .profile-avatar-section {
    margin-bottom: 0;
  }
}
.user-details-container .user-profile-card .profile-avatar-section .avatar-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-details-container .user-profile-card .profile-avatar-section .avatar-container .user-avatar {
  width: 120px !important;
  height: 120px !important;
  font-size: 3rem;
  border: 4px solid #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}
.user-details-container .user-profile-card .profile-avatar-section .avatar-container .user-avatar:hover {
  transform: scale(1.05);
}
.user-details-container .user-profile-card .profile-avatar-section .avatar-container .avatar-status {
  margin-top: 1rem;
}
.user-details-container .user-profile-card .profile-info-section .profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}
.user-details-container .user-profile-card .profile-info-section .profile-header .profile-name-section .profile-name {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-header .profile-name-section .profile-name {
  color: var(--cui-body-color, #fff);
}
.user-details-container .user-profile-card .profile-info-section .profile-header .profile-name-section .profile-username {
  font-size: 1.2rem;
  color: #6c757d;
  margin: 0;
  font-weight: 500;
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-header .profile-name-section .profile-username {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .user-profile-card .profile-info-section .profile-header .profile-id-section .user-id-badge {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.user-details-container .user-profile-card .profile-info-section .profile-header .profile-id-section .user-id-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
  border-color: rgba(255, 255, 255, 0.3);
}
.user-details-container .user-profile-card .profile-info-section .profile-contact-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item:hover {
  background: rgb(248, 249, 250);
  transform: translateX(5px);
}
.user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item .contact-icon {
  color: #6c757d;
  margin-right: 0.75rem;
  font-size: 1.1rem;
}
.user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item .contact-text {
  font-size: 1rem;
  color: #495057;
  font-weight: 500;
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item {
  background: rgba(44, 48, 52, 0.8);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item:hover {
  background: rgb(44, 48, 52);
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item .contact-icon {
  color: var(--cui-secondary-color, #8a93a2);
}
html[data-coreui-theme=dark] .user-details-container .user-profile-card .profile-info-section .profile-contact-info .contact-item .contact-text {
  color: var(--cui-body-color, #fff);
}
.user-details-container .user-status-badge,
.user-details-container .session-status-badge {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  font-weight: 600;
  border: 2px solid transparent;
}
.user-details-container .user-status-badge svg,
.user-details-container .session-status-badge svg {
  font-size: 0.8rem;
}
.user-details-container .user-status-badge.badge-success,
.user-details-container .session-status-badge.badge-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-color: rgba(255, 255, 255, 0.3);
}
.user-details-container .user-status-badge.badge-danger,
.user-details-container .session-status-badge.badge-danger {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
  border-color: rgba(255, 255, 255, 0.3);
}
.user-details-container .user-details-tabs {
  border: none;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
html[data-coreui-theme=dark] .user-details-container .user-details-tabs {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.user-details-container .user-details-tabs .tabs-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1.5rem 2rem;
}
html[data-coreui-theme=dark] .user-details-container .user-details-tabs .tabs-header {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.user-details-container .user-details-tabs .tabs-header .custom-tabs {
  border: none;
  gap: 0.5rem;
}
.user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link {
  border: none;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: #6c757d;
  background: transparent;
  transition: all 0.3s ease;
  position: relative;
}
.user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link:hover {
  color: #495057;
  background: rgba(255, 255, 255, 0.7);
  transform: translateY(-2px);
}
.user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link.active {
  color: #0d6efd;
  background: white;
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.2);
  border: 2px solid rgba(13, 110, 253, 0.1);
}
html[data-coreui-theme=dark] .user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link.active {
  background: var(--cui-dark-bg, #212631);
  color: var(--cui-primary, #0d6efd);
  border-color: var(--cui-primary, #0d6efd);
}
.user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link .tab-badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}
.user-details-container .user-details-tabs .tabs-content {
  padding: 2rem;
  background: white;
}
html[data-coreui-theme=dark] .user-details-container .user-details-tabs .tabs-content {
  background: var(--cui-dark-bg, #212631);
}
.user-details-container .info-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;
  min-height: 730px;
}
.user-details-container .info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
html[data-coreui-theme=dark] .user-details-container .info-card {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .user-details-container .info-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.user-details-container .info-card .info-card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
  border-radius: 16px 16px 0 0;
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-card-header {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.user-details-container .info-card .info-card-header h6 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c3e50;
  display: flex;
  align-items: center;
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-card-header h6 {
  color: var(--cui-body-color, #fff);
}
.user-details-container .info-card .info-card-header svg {
  color: #6c757d;
  font-size: 1.2rem;
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-card-header svg {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .info-card .card-body {
  padding: 1.5rem;
}
.user-details-container .info-card .info-grid {
  display: grid;
  gap: 1.5rem;
}
.user-details-container .info-card .info-grid .info-item .info-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-grid .info-item .info-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .info-card .info-grid .info-item .info-value {
  font-size: 1rem;
  color: #495057;
  font-weight: 500;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.user-details-container .info-card .info-grid .info-item .info-value:last-child {
  border-bottom: none;
}
.user-details-container .info-card .info-grid .info-item .info-value .system-badge {
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
}
.user-details-container .info-card .info-grid .info-item .info-value svg {
  color: #6c757d;
  font-size: 0.9rem;
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-grid .info-item .info-value {
  color: var(--cui-body-color, #fff);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .user-details-container .info-card .info-grid .info-item .info-value svg {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .sessions-container .sessions-header,
.user-details-container .sessions-container .passwords-header,
.user-details-container .passwords-container .sessions-header,
.user-details-container .passwords-container .passwords-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem 0;
}
.user-details-container .sessions-container .sessions-header h5,
.user-details-container .sessions-container .passwords-header h5,
.user-details-container .passwords-container .sessions-header h5,
.user-details-container .passwords-container .passwords-header h5 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-header h5,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-header h5,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-header h5,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-header h5 {
  color: var(--cui-body-color, #fff);
}
.user-details-container .sessions-container .sessions-header .sessions-count,
.user-details-container .sessions-container .sessions-header .passwords-count,
.user-details-container .sessions-container .passwords-header .sessions-count,
.user-details-container .sessions-container .passwords-header .passwords-count,
.user-details-container .passwords-container .sessions-header .sessions-count,
.user-details-container .passwords-container .sessions-header .passwords-count,
.user-details-container .passwords-container .passwords-header .sessions-count,
.user-details-container .passwords-container .passwords-header .passwords-count {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  font-weight: 600;
}
.user-details-container .sessions-container .sessions-table,
.user-details-container .sessions-container .passwords-table,
.user-details-container .passwords-container .sessions-table,
.user-details-container .passwords-container .passwords-table {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.user-details-container .sessions-container .sessions-table .table-header,
.user-details-container .sessions-container .passwords-table .table-header,
.user-details-container .passwords-container .sessions-table .table-header,
.user-details-container .passwords-container .passwords-table .table-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-weight: 700;
  color: #2c3e50;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-header,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-header,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-header,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-header {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  color: var(--cui-body-color, #fff);
}
.user-details-container .sessions-container .sessions-table .table-row,
.user-details-container .sessions-container .passwords-table .table-row,
.user-details-container .passwords-container .sessions-table .table-row,
.user-details-container .passwords-container .passwords-table .table-row {
  transition: all 0.3s ease;
}
.user-details-container .sessions-container .sessions-table .table-row:hover,
.user-details-container .sessions-container .passwords-table .table-row:hover,
.user-details-container .passwords-container .sessions-table .table-row:hover,
.user-details-container .passwords-container .passwords-table .table-row:hover {
  background: rgba(13, 110, 253, 0.02);
  transform: scale(1.01);
}
.user-details-container .sessions-container .sessions-table .table-row .table-cell,
.user-details-container .sessions-container .passwords-table .table-row .table-cell,
.user-details-container .passwords-container .sessions-table .table-row .table-cell,
.user-details-container .passwords-container .passwords-table .table-row .table-cell {
  padding: 1.25rem 1.5rem;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell {
  color: var(--cui-body-color, #fff);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.user-details-container .sessions-container .sessions-table .table-row .table-cell .session-id-badge,
.user-details-container .sessions-container .sessions-table .table-row .table-cell .password-id-badge,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .session-id-badge,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .password-id-badge,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .session-id-badge,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .password-id-badge,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .session-id-badge,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .password-id-badge {
  font-size: 0.8rem;
  padding: 0.4rem 0.8rem;
  font-weight: 600;
}
.user-details-container .sessions-container .sessions-table .table-row .table-cell .date-cell,
.user-details-container .sessions-container .sessions-table .table-row .table-cell .user-cell,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .date-cell,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .user-cell,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .date-cell,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .user-cell,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .date-cell,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .user-cell {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #495057;
}
.user-details-container .sessions-container .sessions-table .table-row .table-cell .date-cell svg,
.user-details-container .sessions-container .sessions-table .table-row .table-cell .user-cell svg,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .date-cell svg,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .user-cell svg,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .date-cell svg,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .user-cell svg,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .date-cell svg,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .user-cell svg {
  color: #6c757d;
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell .date-cell,
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell .user-cell,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell .date-cell,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell .user-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell .date-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell .user-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell .date-cell,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell .user-cell {
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell .date-cell svg,
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell .user-cell svg,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell .date-cell svg,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell .user-cell svg,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell .date-cell svg,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell .user-cell svg,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell .date-cell svg,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell .user-cell svg {
  color: var(--cui-secondary-color, #8a93a2);
}
.user-details-container .sessions-container .sessions-table .table-row .table-cell .jwt-token,
.user-details-container .sessions-container .passwords-table .table-row .table-cell .jwt-token,
.user-details-container .passwords-container .sessions-table .table-row .table-cell .jwt-token,
.user-details-container .passwords-container .passwords-table .table-row .table-cell .jwt-token {
  background: rgba(248, 249, 250, 0.8);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8rem;
  color: #6c757d;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
html[data-coreui-theme=dark] .user-details-container .sessions-container .sessions-table .table-row .table-cell .jwt-token,
html[data-coreui-theme=dark] .user-details-container .sessions-container .passwords-table .table-row .table-cell .jwt-token,
html[data-coreui-theme=dark] .user-details-container .passwords-container .sessions-table .table-row .table-cell .jwt-token,
html[data-coreui-theme=dark] .user-details-container .passwords-container .passwords-table .table-row .table-cell .jwt-token {
  background: rgba(44, 48, 52, 0.8);
  color: var(--cui-secondary-color, #8a93a2);
  border-color: var(--cui-dark-border-subtle, #333);
}
.user-details-container .empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #6c757d;
}
.user-details-container .empty-state .empty-icon {
  color: #dee2e6;
  margin-bottom: 1.5rem;
}
.user-details-container .empty-state h5 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
}
.user-details-container .empty-state p {
  font-size: 1rem;
  margin: 0;
  max-width: 400px;
  margin: 0 auto;
}
html[data-coreui-theme=dark] .user-details-container .empty-state {
  color: var(--cui-secondary-color, #8a93a2);
}
html[data-coreui-theme=dark] .user-details-container .empty-state .empty-icon {
  color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .user-details-container .empty-state h5 {
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .user-details-container .empty-state p {
  color: var(--cui-secondary-color, #8a93a2);
}
@media (max-width: 768px) {
  .user-details-container {
    padding: 1rem;
  }
  .user-details-container .user-details-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  .user-details-container .user-details-header .header-left {
    width: 100%;
    justify-content: space-between;
  }
  .user-details-container .user-details-header .header-left .header-title h3 {
    font-size: 1.5rem;
  }
  .user-details-container .user-details-header .header-actions {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .user-details-container .user-profile-card .card-body {
    padding: 1.5rem;
  }
  .user-details-container .user-profile-card .profile-info-section .profile-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .user-details-container .user-details-tabs .tabs-header {
    padding: 1rem;
  }
  .user-details-container .user-details-tabs .tabs-header .custom-tabs {
    flex-direction: column;
  }
  .user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item {
    width: 100%;
  }
  .user-details-container .user-details-tabs .tabs-header .custom-tabs .nav-item .custom-tab-link {
    text-align: center;
    padding: 0.75rem 1rem;
  }
  .user-details-container .user-details-tabs .tabs-content {
    padding: 1rem;
  }
  .user-details-container .info-card .info-card-header {
    padding: 1rem;
  }
  .user-details-container .info-card .card-body {
    padding: 1rem;
  }
  .user-details-container .sessions-table,
  .user-details-container .passwords-table {
    font-size: 0.8rem;
  }
  .user-details-container .sessions-table .table-header,
  .user-details-container .sessions-table .table-cell,
  .user-details-container .passwords-table .table-header,
  .user-details-container .passwords-table .table-cell {
    padding: 0.75rem 0.5rem;
  }
}
@media (max-width: 576px) {
  .user-details-container .sessions-table .table-cell .jwt-token,
  .user-details-container .passwords-table .table-cell .jwt-token {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/UserDetails/UserDetails.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,6DAAA;EACA,iBAAA;AAAJ;AAGI;EACE,6DAAA;EACA,kCAAA;AADN;AAKI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAHN;AAKM;EACE,iBAAA;EACA,gBAAA;AAHR;AAQI;;EAEE,aAAA;AANN;AAQM;;;;EAEE,mBAAA;EACA,YAAA;EACA,yCAAA;EACA,iBAAA;EACA,eAAA;AAJR;AAMQ;;;;EACE,iBAAA;AADV;AAOI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,qCAAA;AALN;AAOM;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AALR;AAQM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AANR;AAQQ;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AANV;AAQU;EACE,qBAAA;EACA,2BAAA;EACA,0CAAA;AANZ;AAWY;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AATd;AAWc;EACE,kCAAA;AAThB;AAaY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAXd;AAac;EACE,0CAAA;AAXhB;AAkBQ;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAhBV;AAkBU;EACE,qBAAA;EACA,2BAAA;EACA,8CAAA;AAhBZ;AAuBI;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,6DAAA;AArBN;AAuBM;EACE,4GAAA;EACA,yCAAA;AArBR;AAwBM;EACE,eAAA;AAtBR;AAyBM;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAvBR;AAyBQ;EANF;IAOI,gBAAA;EAtBR;AACF;AAwBQ;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAtBV;AAwBU;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,0CAAA;EACA,+BAAA;AAtBZ;AAwBY;EACE,sBAAA;AAtBd;AA0BU;EACE,gBAAA;AAxBZ;AA8BQ;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA5BV;AA+BwB;EACV,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AA7Bd;AA+Bc;EACE,kCAAA;AA7BhB;AAiCY;EACE,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AA/Bd;AAiCc;EACE,0CAAA;AA/BhB;AAqCY;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;AAnCd;AAqCc;EACE,2BAAA;EACA,8CAAA;EACA,sCAAA;AAnChB;AAyCQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvCV;AAyCoB;EACR,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;AAvCZ;AAyCY;EACE,8BAAA;EACA,0BAAA;AAvCd;AA0CY;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AAxCd;AA2CY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzCd;AA4CY;EACE,iCAAA;EACA,iDAAA;AA1Cd;AA4Cc;EACE,2BAAA;AA1ChB;AA6Cc;EACE,0CAAA;AA3ChB;AA8Cc;EACE,kCAAA;AA5ChB;AAqDI;;EAEE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;AAnDN;AAqDM;;EACE,iBAAA;AAlDR;AAqDM;;EACE,6DAAA;EACA,sCAAA;AAlDR;AAqDM;;EACE,6DAAA;EACA,sCAAA;AAlDR;AAuDI;EACE,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;AArDN;AAuDM;EACE,yCAAA;AArDR;AAwDc;EACJ,6DAAA;EACA,2CAAA;EACA,oBAAA;AAtDV;AAwDU;EACE,4GAAA;EACA,wDAAA;AAtDZ;AAyDQ;EACE,YAAA;EACA,WAAA;AAvDV;AA0DY;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAxDd;AA0Dc;EACE,cAAA;EACA,oCAAA;EACA,2BAAA;AAxDhB;AA2Dc;EACE,cAAA;EACA,iBAAA;EACA,8CAAA;EACA,yCAAA;AAzDhB;AA2DgB;EACE,uCAAA;EACA,kCAAA;EACA,yCAAA;AAzDlB;AA6Dc;EACE,iBAAA;EACA,uBAAA;AA3DhB;AAkEM;EACE,aAAA;EACA,iBAAA;AAhER;AAkEQ;EACE,uCAAA;AAhEV;AAsEI;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,iBAAA;AApEN;AAqEM;EACE,2BAAA;EACA,0CAAA;AAnER;AAsEM;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AApER;AAsEQ;EACE,yCAAA;AApEV;AAwEc;EACJ,6DAAA;EACA,4CAAA;EACA,uBAAA;EACA,4BAAA;AAtEV;AAwEU;EACE,4GAAA;EACA,wDAAA;AAtEZ;AAyEU;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAvEZ;AAyEY;EACE,kCAAA;AAvEd;AA2EU;EACE,cAAA;EACA,iBAAA;AAzEZ;AA2EY;EACE,0CAAA;AAzEd;AA8EM;EACE,eAAA;AA5ER;AA+EM;EACE,aAAA;EACA,WAAA;AA7ER;AAgFoB;EACR,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AA9EZ;AAgFY;EACE,0CAAA;AA9Ed;AAkFU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AAhFZ;AAkFY;EACE,mBAAA;AAhFd;AAmFY;EACE,kBAAA;EACA,sBAAA;AAjFd;AAoFY;EACE,cAAA;EACA,iBAAA;AAlFd;AAqFY;EACE,kCAAA;EACA,wDAAA;AAnFd;AAqFc;EACE,0CAAA;AAnFhB;AA8FM;;;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA1FR;AA4FQ;;;;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAvFV;AAyFU;;;;EACE,kCAAA;AApFZ;AAwFQ;;;;;;;;EAEE,kBAAA;EACA,oBAAA;EACA,gBAAA;AAhFV;AAoFM;;;;EAEE,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,qCAAA;AAhFR;AAkFQ;;;;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AA7EV;AAgFQ;;;;EACE,6DAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AA3EV;AA6EU;;;;EACE,4GAAA;EACA,kCAAA;AAxEZ;AA4EkB;;;;EACN,yBAAA;AAvEZ;AAyEY;;;;EACE,oCAAA;EACA,sBAAA;AApEd;AAuEY;;;;EACE,uBAAA;EACA,YAAA;EACA,4CAAA;EACA,sBAAA;AAlEd;AAoEc;;;;EACE,kCAAA;EACA,wDAAA;AA/DhB;AAkEY;;;;;;;;EAEE,iBAAA;EACA,sBAAA;EACA,gBAAA;AA1Dd;AA6DwB;;;;;;;;EAEV,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AArDd;AAuDc;;;;;;;;EACE,cAAA;AA9ChB;AAiDc;;;;;;;;EACE,kCAAA;AAxChB;AA0CgB;;;;;;;;EACE,0CAAA;AAjClB;AAsCY;;;;EACE,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;AAjCd;AAmCc;;;;EACE,iCAAA;EACA,0CAAA;EACA,iDAAA;AA9BhB;AAuCI;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AArCN;AAuCM;EACE,cAAA;EACA,qBAAA;AArCR;AAwCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtCR;AAyCM;EACE,eAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AAvCR;AA0CM;EACE,0CAAA;AAxCR;AA0CQ;EACE,0CAAA;AAxCV;AA2CQ;EACE,kCAAA;AAzCV;AA4CQ;EACE,0CAAA;AA1CV;AAgDI;EAjpBJ;IAkpBM,aAAA;EA7CJ;EA+CI;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EA7CN;EA+CM;IACE,WAAA;IACA,8BAAA;EA7CR;EAgDU;IACE,iBAAA;EA9CZ;EAmDM;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAjDR;EAsDM;IACE,eAAA;EApDR;EAwDQ;IACE,sBAAA;IACA,mBAAA;IACA,kBAAA;EAtDV;EA4DM;IACE,aAAA;EA1DR;EA4DQ;IACE,sBAAA;EA1DV;EA4DU;IACE,WAAA;EA1DZ;EA4DY;IACE,kBAAA;IACA,qBAAA;EA1Dd;EAgEM;IACE,aAAA;EA9DR;EAmEM;IACE,aAAA;EAjER;EAoEM;IACE,aAAA;EAlER;EAsEI;;IAEE,iBAAA;EApEN;EAsEM;;;;IAEE,uBAAA;EAlER;AACF;AAsEI;EAIM;;IACE,iBAAA;IACA,uBAAA;EAtEV;AACF","sourcesContent":["// UserDetails.scss - Spesifik stiller\n.user-details-container {\n    padding: 1.5rem;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    min-height: 100vh;\n    \n    // Dark mode support\n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);\n      color: var(--cui-body-color, #fff);\n    }\n  \n    // Loading state\n    .user-details-loading {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      min-height: 400px;\n      text-align: center;\n  \n      p {\n        font-size: 1.1rem;\n        margin-top: 1rem;\n      }\n    }\n  \n    // Error states\n    .user-details-error,\n    .user-details-not-found {\n      padding: 2rem;\n  \n      .error-alert,\n      .warning-alert {\n        border-radius: 12px;\n        border: none;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        font-size: 1.1rem;\n        padding: 1.5rem;\n  \n        svg {\n          font-size: 1.2rem;\n        }\n      }\n    }\n  \n    // Header section\n    .user-details-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 2rem;\n      padding: 1.5rem;\n      background: white;\n      border-radius: 16px;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n      border: 1px solid rgba(0, 0, 0, 0.05);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: var(--cui-dark-bg, #212631);\n        border-color: var(--cui-dark-border-subtle, #333);\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n      }\n  \n      .header-left {\n        display: flex;\n        align-items: center;\n        gap: 1.5rem;\n  \n        .back-button {\n          border-radius: 12px;\n          border: 2px solid #e9ecef;\n          padding: 0.75rem 1.5rem;\n          font-weight: 500;\n          transition: all 0.3s ease;\n  \n          &:hover {\n            border-color: #6c757d;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n          }\n        }\n  \n                  .header-title {\n            h3 {\n              margin: 0;\n              font-size: 1.8rem;\n              font-weight: 700;\n              color: #2c3e50;\n              line-height: 1.2;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n              }\n            }\n\n            .header-subtitle {\n              font-size: 1rem;\n              color: #6c757d;\n              font-weight: 500;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-secondary-color, #8a93a2);\n              }\n            }\n          }\n      }\n  \n      .header-actions {\n        .dropdown-toggle {\n          border-radius: 12px;\n          padding: 0.75rem 1rem;\n          border: 2px solid #e3f2fd;\n          transition: all 0.3s ease;\n  \n          &:hover {\n            border-color: #2196f3;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);\n          }\n        }\n      }\n    }\n  \n    // User profile card\n    .user-profile-card {\n      margin-bottom: 2rem;\n      border: none;\n      border-radius: 20px;\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n      overflow: hidden;\n      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, var(--cui-dark-bg-subtle, #2c3034) 100%);\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n      }\n  \n      .card-body {\n        padding: 2.5rem;\n      }\n  \n      .profile-avatar-section {\n        display: flex;\n        justify-content: center;\n        align-items: flex-start;\n        margin-bottom: 2rem;\n  \n        @media (min-width: 992px) {\n          margin-bottom: 0;\n        }\n  \n        .avatar-container {\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n  \n          .user-avatar {\n            width: 120px !important;\n            height: 120px !important;\n            font-size: 3rem;\n            border: 4px solid #ffffff;\n            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n            transition: transform 0.3s ease;\n  \n            &:hover {\n              transform: scale(1.05);\n            }\n          }\n  \n          .avatar-status {\n            margin-top: 1rem;\n          }\n        }\n      }\n  \n      .profile-info-section {\n        .profile-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: flex-start;\n          margin-bottom: 2rem;\n          flex-wrap: wrap;\n          gap: 1rem;\n  \n          .profile-name-section {\n                        .profile-name {\n              font-size: 2rem;\n              font-weight: 700;\n              color: #2c3e50;\n              margin-bottom: 0.5rem;\n              line-height: 1.2;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n              }\n            }\n\n            .profile-username {\n              font-size: 1.2rem;\n              color: #6c757d;\n              margin: 0;\n              font-weight: 500;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-secondary-color, #8a93a2);\n              }\n            }\n          }\n  \n          .profile-id-section {\n            .user-id-badge {\n              font-size: 0.9rem;\n              padding: 0.5rem 1rem;\n              cursor: pointer;\n              transition: all 0.3s ease;\n              border: 2px solid transparent;\n  \n              &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);\n                border-color: rgba(255, 255, 255, 0.3);\n              }\n            }\n          }\n        }\n  \n        .profile-contact-info {\n          display: flex;\n          flex-direction: column;\n          gap: 1rem;\n  \n                    .contact-item {\n            display: flex;\n            align-items: center;\n            padding: 0.75rem 1rem;\n            background: rgba(248, 249, 250, 0.8);\n            border-radius: 12px;\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            transition: all 0.3s ease;\n\n            &:hover {\n              background: rgba(248, 249, 250, 1);\n              transform: translateX(5px);\n            }\n\n            .contact-icon {\n              color: #6c757d;\n              margin-right: 0.75rem;\n              font-size: 1.1rem;\n            }\n\n            .contact-text {\n              font-size: 1rem;\n              color: #495057;\n              font-weight: 500;\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              background: rgba(44, 48, 52, 0.8);\n              border-color: var(--cui-dark-border-subtle, #333);\n              \n              &:hover {\n                background: rgba(44, 48, 52, 1);\n              }\n              \n              .contact-icon {\n                color: var(--cui-secondary-color, #8a93a2);\n              }\n              \n              .contact-text {\n                color: var(--cui-body-color, #fff);\n              }\n            }\n          }\n        }\n      }\n    }\n  \n    // Status badges\n    .user-status-badge,\n    .session-status-badge {\n      font-size: 0.85rem;\n      padding: 0.5rem 1rem;\n      font-weight: 600;\n      border: 2px solid transparent;\n  \n      svg {\n        font-size: 0.8rem;\n      }\n  \n      &.badge-success {\n        background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n        border-color: rgba(255, 255, 255, 0.3);\n      }\n  \n      &.badge-danger {\n        background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);\n        border-color: rgba(255, 255, 255, 0.3);\n      }\n    }\n  \n    // Tabs section\n    .user-details-tabs {\n      border: none;\n      border-radius: 20px;\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n      overflow: hidden;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n      }\n  \n              .tabs-header {\n          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n          border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n          padding: 1.5rem 2rem;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n            border-bottom-color: var(--cui-dark-border-subtle, #333);\n          }\n  \n        .custom-tabs {\n          border: none;\n          gap: 0.5rem;\n  \n          .nav-item {\n            .custom-tab-link {\n              border: none;\n              border-radius: 12px;\n              padding: 1rem 1.5rem;\n              font-weight: 600;\n              color: #6c757d;\n              background: transparent;\n              transition: all 0.3s ease;\n              position: relative;\n  \n              &:hover {\n                color: #495057;\n                background: rgba(255, 255, 255, 0.7);\n                transform: translateY(-2px);\n              }\n  \n              &.active {\n                color: #0d6efd;\n                background: white;\n                box-shadow: 0 4px 12px rgba(13, 110, 253, 0.2);\n                border: 2px solid rgba(13, 110, 253, 0.1);\n                \n                html[data-coreui-theme=\"dark\"] & {\n                  background: var(--cui-dark-bg, #212631);\n                  color: var(--cui-primary, #0d6efd);\n                  border-color: var(--cui-primary, #0d6efd);\n                }\n              }\n  \n              .tab-badge {\n                font-size: 0.7rem;\n                padding: 0.25rem 0.5rem;\n              }\n            }\n          }\n        }\n      }\n  \n      .tabs-content {\n        padding: 2rem;\n        background: white;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: var(--cui-dark-bg, #212631);\n        }\n      }\n    }\n  \n    // Info cards\n    .info-card {\n      border: none;\n      border-radius: 16px;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n      margin-bottom: 1.5rem;\n      transition: transform 0.3s ease;\n      min-height: 730px;\n      &:hover {\n        transform: translateY(-4px);\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n      }\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: var(--cui-dark-bg, #212631);\n        border-color: var(--cui-dark-border-subtle, #333);\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n        \n        &:hover {\n          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n        }\n      }\n  \n              .info-card-header {\n          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n          border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n          padding: 1.25rem 1.5rem;\n          border-radius: 16px 16px 0 0;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n            border-bottom-color: var(--cui-dark-border-subtle, #333);\n          }\n\n          h6 {\n            margin: 0;\n            font-size: 1.1rem;\n            font-weight: 700;\n            color: #2c3e50;\n            display: flex;\n            align-items: center;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-body-color, #fff);\n            }\n          }\n\n          svg {\n            color: #6c757d;\n            font-size: 1.2rem;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-secondary-color, #8a93a2);\n            }\n          }\n        }\n  \n      .card-body {\n        padding: 1.5rem;\n      }\n  \n      .info-grid {\n        display: grid;\n        gap: 1.5rem;\n  \n        .info-item {\n                    .info-label {\n            display: block;\n            font-size: 0.9rem;\n            font-weight: 600;\n            color: #6c757d;\n            margin-bottom: 0.5rem;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-secondary-color, #8a93a2);\n            }\n          }\n\n          .info-value {\n            font-size: 1rem;\n            color: #495057;\n            font-weight: 500;\n            padding: 0.75rem 0;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n\n            &:last-child {\n              border-bottom: none;\n            }\n\n            .system-badge {\n              font-size: 0.85rem;\n              padding: 0.4rem 0.8rem;\n            }\n\n            svg {\n              color: #6c757d;\n              font-size: 0.9rem;\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-body-color, #fff);\n              border-bottom-color: var(--cui-dark-border-subtle, #333);\n              \n              svg {\n                color: var(--cui-secondary-color, #8a93a2);\n              }\n            }\n          }\n        }\n      }\n    }\n  \n    // Tables\n    .sessions-container,\n    .passwords-container {\n      .sessions-header,\n      .passwords-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1.5rem;\n        padding: 1rem 0;\n  \n        h5 {\n          margin: 0;\n          font-size: 1.4rem;\n          font-weight: 700;\n          color: #2c3e50;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            color: var(--cui-body-color, #fff);\n          }\n        }\n  \n        .sessions-count,\n        .passwords-count {\n          font-size: 0.85rem;\n          padding: 0.5rem 1rem;\n          font-weight: 600;\n        }\n      }\n  \n      .sessions-table,\n      .passwords-table {\n        border-radius: 12px;\n        overflow: hidden;\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n        border: 1px solid rgba(0, 0, 0, 0.05);\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: var(--cui-dark-bg, #212631);\n          border-color: var(--cui-dark-border-subtle, #333);\n          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n        }\n  \n        .table-header {\n          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n          font-weight: 700;\n          color: #2c3e50;\n          border: none;\n          padding: 1rem 1.5rem;\n          font-size: 0.9rem;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n            color: var(--cui-body-color, #fff);\n          }\n        }\n  \n                  .table-row {\n            transition: all 0.3s ease;\n\n            &:hover {\n              background: rgba(13, 110, 253, 0.02);\n              transform: scale(1.01);\n            }\n\n            .table-cell {\n              padding: 1.25rem 1.5rem;\n              border: none;\n              border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n              vertical-align: middle;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n                border-bottom-color: var(--cui-dark-border-subtle, #333);\n              }\n  \n            .session-id-badge,\n            .password-id-badge {\n              font-size: 0.8rem;\n              padding: 0.4rem 0.8rem;\n              font-weight: 600;\n            }\n  \n                        .date-cell,\n            .user-cell {\n              display: flex;\n              align-items: center;\n              font-size: 0.9rem;\n              color: #495057;\n\n              svg {\n                color: #6c757d;\n              }\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n                \n                svg {\n                  color: var(--cui-secondary-color, #8a93a2);\n                }\n              }\n            }\n  \n            .jwt-token {\n              background: rgba(248, 249, 250, 0.8);\n              padding: 0.5rem 0.75rem;\n              border-radius: 8px;\n              font-size: 0.8rem;\n              color: #6c757d;\n              border: 1px solid rgba(0, 0, 0, 0.05);\n              \n              html[data-coreui-theme=\"dark\"] & {\n                background: rgba(44, 48, 52, 0.8);\n                color: var(--cui-secondary-color, #8a93a2);\n                border-color: var(--cui-dark-border-subtle, #333);\n              }\n            }\n          }\n        }\n      }\n    }\n  \n        // Empty states\n    .empty-state {\n      text-align: center;\n      padding: 4rem 2rem;\n      color: #6c757d;\n\n      .empty-icon {\n        color: #dee2e6;\n        margin-bottom: 1.5rem;\n      }\n\n      h5 {\n        font-size: 1.3rem;\n        font-weight: 600;\n        color: #495057;\n        margin-bottom: 1rem;\n      }\n\n      p {\n        font-size: 1rem;\n        margin: 0;\n        max-width: 400px;\n        margin: 0 auto;\n      }\n      \n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-secondary-color, #8a93a2);\n        \n        .empty-icon {\n          color: var(--cui-dark-border-subtle, #333);\n        }\n        \n        h5 {\n          color: var(--cui-body-color, #fff);\n        }\n        \n        p {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n    }\n  \n    // Responsive design\n    @media (max-width: 768px) {\n      padding: 1rem;\n  \n      .user-details-header {\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1rem;\n  \n        .header-left {\n          width: 100%;\n          justify-content: space-between;\n  \n          .header-title {\n            h3 {\n              font-size: 1.5rem;\n            }\n          }\n        }\n  \n        .header-actions {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n        }\n      }\n  \n      .user-profile-card {\n        .card-body {\n          padding: 1.5rem;\n        }\n  \n        .profile-info-section {\n          .profile-header {\n            flex-direction: column;\n            align-items: center;\n            text-align: center;\n          }\n        }\n      }\n  \n      .user-details-tabs {\n        .tabs-header {\n          padding: 1rem;\n  \n          .custom-tabs {\n            flex-direction: column;\n  \n            .nav-item {\n              width: 100%;\n  \n              .custom-tab-link {\n                text-align: center;\n                padding: 0.75rem 1rem;\n              }\n            }\n          }\n        }\n  \n        .tabs-content {\n          padding: 1rem;\n        }\n      }\n  \n      .info-card {\n        .info-card-header {\n          padding: 1rem;\n        }\n  \n        .card-body {\n          padding: 1rem;\n        }\n      }\n  \n      .sessions-table,\n      .passwords-table {\n        font-size: 0.8rem;\n  \n        .table-header,\n        .table-cell {\n          padding: 0.75rem 0.5rem;\n        }\n      }\n    }\n  \n    @media (max-width: 576px) {\n      .sessions-table,\n      .passwords-table {\n        .table-cell {\n          .jwt-token {\n            font-size: 0.7rem;\n            padding: 0.25rem 0.5rem;\n          }\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
